module.exports = __webpack_public_path__ + "img/SketchPngb2d55bc005aa8eefc5aa7af480e5a54bca9a5cebe96f639a4bb1a135af391c0c.03e79ba5.png";